import { ChevronLeft, Zap, CircleUser } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export default function ProstoHeader({ title, back = false, dark = false }) {
  const navigate = useNavigate();
  return (
    <header className={`sticky top-0 z-40 border-b px-4 py-3 backdrop-blur-xl ${dark ? "border-blue-200/15 bg-[#071329]/90" : "border-slate-200 bg-white/90"}`}>
      <div className="flex items-center gap-3">
        {back ? (
          <>
            <button
              data-testid="prosto-back-button"
              onClick={() => (window.history.state?.idx > 0 ? navigate(-1) : navigate("/prosto"))}
              className={`grid h-9 w-9 place-items-center rounded-full active:scale-95 transition ${dark ? "bg-blue-300/10 text-blue-100" : "bg-slate-100 text-slate-700"}`}
            >
              <ChevronLeft size={22} />
            </button>
            <div
              data-testid="prosto-header-title"
              className={`truncate font-display text-[17px] font-bold leading-tight ${dark ? "text-white" : "text-slate-900"}`}
            >
              {title}
            </div>
          </>
        ) : (
          <>
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 grid place-items-center rounded-2xl bg-[#2F6BFF] text-white shadow-lg shadow-blue-500/25">
                <Zap size={20} className="fill-white" />
              </span>
              <span className="font-display text-xl font-extrabold text-slate-900 tracking-tight">
                ProstoApp
              </span>
            </div>
            <button
              data-testid="prosto-profile-button"
              onClick={() => toast.info("Личный профиль скоро")}
              className="ml-auto w-9 h-9 grid place-items-center rounded-full bg-slate-100 text-slate-600 active:scale-95 transition"
            >
              <CircleUser size={22} />
            </button>
          </>
        )}
      </div>
    </header>
  );
}
